import React from 'react'
import { DownloadOutlined } from '@ant-design/icons'
import { isMobile } from '../../../../utils'
import './course-resources.scss'

/**
 * 课程资源（移动端）
 * - 非移动端返回 null，桌面端仍走 index.js 中的侧边栏实现
 * - 点击整行下载对应资源
 */
const CourseResources = ({ markdown, downLoad }) => {
    const resources = markdown?.data?.resources || []

    if (!isMobile() || !resources.length) {
        return null
    }

    return (
        <div className="course-res">
            <div className="course-res-header">
                <span className="course-res-title">课程资源</span>
                <span className="course-res-line" />
            </div>
            <div className="course-res-list">
                {resources.map(source => (
                    <div
                        key={source.id}
                        className="course-res-item"
                        onClick={() => source.content && downLoad && downLoad(source.content)}
                    >
                        <span className="course-res-name" title={source.title}>
                            {source.title}
                        </span>
                        <DownloadOutlined className="course-res-icon" />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CourseResources
